document.addEventListener('DOMContentLoaded', () => {
            const shopMenu = document.querySelector('nav .shop-menu');
            const dropdown = document.querySelector('nav .dropdown-container');
            const accordionTabs = document.querySelectorAll('nav .accordion-tab');
            const accordionPanels = document.querySelectorAll('nav .accordion-panel');

            // Desktop dropdown hover functionality
            if (window.innerWidth > 768) {
                shopMenu.addEventListener('mouseenter', () => {
                    dropdown.classList.add('active');
                });

                shopMenu.addEventListener('mouseleave', () => {
                    setTimeout(() => {
                        if (!dropdown.matches(':hover') && !shopMenu.matches(':hover')) {
                            dropdown.classList.remove('active');
                        }
                    }, 100);
                });

                dropdown.addEventListener('mouseleave', () => {
                    dropdown.classList.remove('active');
                });

                // Desktop accordion functionality
                accordionTabs.forEach(tab => {
                    tab.addEventListener('mouseenter', () => {
                        const targetId = tab.getAttribute('data-target');

                        accordionTabs.forEach(t => t.classList.remove('active'));
                        accordionPanels.forEach(p => p.classList.remove('active'));

                        tab.classList.add('active');
                        const targetPanel = document.getElementById(targetId);
                        if (targetPanel) {
                            targetPanel.classList.add('active');
                        }
                    });
                });

                if (accordionTabs.length > 0 && accordionPanels.length > 0) {
                    accordionTabs[0].classList.add('active');
                    accordionPanels[0].classList.add('active');
                }
            }

            // Mobile menu functionality
            const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
            const mobileNav = document.querySelector('.mobile-nav');
            const mobileOverlay = document.querySelector('.mobile-overlay');
            const mobileShopMenu = document.querySelector('.mobile-nav .shop-menu');
            const mobileAccordionTabs = document.querySelectorAll('.mobile-nav .accordion-tab');
            const mobileAccordionPanels = document.querySelectorAll('.mobile-nav .accordion-panel');

            mobileMenuBtn.addEventListener('click', () => {
                mobileMenuBtn.classList.toggle('active');
                mobileNav.classList.toggle('active');
                mobileOverlay.classList.toggle('active');
            });

            mobileOverlay.addEventListener('click', () => {
                mobileMenuBtn.classList.remove('active');
                mobileNav.classList.remove('active');
                mobileOverlay.classList.remove('active');
            });

            // Mobile shop menu toggle
            mobileShopMenu.addEventListener('click', (e) => {
                // Don't interfere with product card clicks
                if (e.target.closest('.products-grid') || e.target.closest('.product-card-header')) {
                    return; // Let the link work normally
                }
                
                // Check if clicking the main shop menu link itself (not the dropdown content)
                if (e.target.tagName === 'A' || e.target.closest('.shop-menu > a')) {
                    e.preventDefault(); // Prevent default link behavior
                    mobileShopMenu.classList.toggle('expanded');
                }
            });

            // Mobile accordion functionality
            mobileAccordionTabs.forEach(tab => {
                tab.addEventListener('click', () => {
                    const targetId = tab.getAttribute('data-target');

                    mobileAccordionTabs.forEach(t => t.classList.remove('active'));
                    mobileAccordionPanels.forEach(p => p.classList.remove('active'));

                    tab.classList.add('active');
                    const targetPanel = document.getElementById(targetId);
                    if (targetPanel) {
                        targetPanel.classList.add('active');
                    }
                });
            });

            // Show first mobile collection by default
            if (mobileAccordionPanels.length > 0) {
                mobileAccordionPanels[0].classList.add('active');
                mobileAccordionTabs[0].classList.add('active');
            }
        });